import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '@app/_service';
import {Const} from "@app/_helper/const";
import {Logger} from "@app/logger";

@Injectable({
  providedIn: 'root'
})
export class AnonymousGuard {

  private readonly log = new Logger();

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isLoggedIn) {
      const account = this.authService.accountValue;
      if (this.authService.isNeed2fa) {
        return true;
      }
      this.log.warn('AnonymousGuard activated!');
      this.router.navigate([`/${Const.URI_HOME}`]);
      return false;
    }
    return true;
  }
}
